import { $api } from "../../../../services/request.config";
import { getDisabilityChildrenAction } from "../getdisabilityChildren.action";

export const getdisabilityChildrenThunkAction = () => async(dispatch) => {
    try {
        const response = await $api("v1/requests/restdays/disabled-child-care/children");
        if (response.status === 200) {
            dispatch(getDisabilityChildrenAction(response.data.map((item) => {
                            return {
                                ...item,
                                id: item.autoCard,
                                name: item.fullName,
                            };
                        })));
        //     dispatch(getDisabilityChildrenAction([
        //         {
        //             "autoCard": 0,
        //             "birthDate": "2025-11-25",
        //             "lastName": "string",
        //             "firstName": "string",
        //             "middleName": "string",
        //             "fullName": "string",
        //         },
        //
        //         {
        //
        //             "autoCard": 160588,
        //
        //             "birthDate": "2011-11-08",
        //
        //             "fullName": "Згвйзжъьчкащьбзсцьоъшцфеъ Дурасуепестджолнъмфъвзехм Аьыглхззмфзйфавиапйщэнции",
        //             "lastName": "string",
        //             "firstName": "string",
        //             "middleName": "string",
        //
        //         },
        //
        //         {
        //
        //             "autoCard": 160589,
        //
        //             "birthDate": "2010-08-02",
        //
        //             "fullName": "Ъщгжзаиблбекногсютлалалвм Тсцехцмцюжкампрэщиижихфзж Ъхунуглумнугэжтрхкшгуькбб",
        //             "lastName": "string",
        //             "firstName": "string",
        //             "middleName": "string",
        //
        //         },
        //
        //     ].map((item) => {
        //         return {
        //             ...item,
        //             id: item.autoCard,
        //             name: item.fullName,
        //         };
        //     })));
        //
        }
    } catch (error) {
        dispatch(getDisabilityChildrenAction([]));
    }
}
